/*eslint-disable*/
import React, { useState } from "react";
import "../../Assests/Globalcss/stylesheet.css";
import logo from "../../Assests/Globalimages/nav-icon (2).png";
import { Modal, Box, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { Gavel, CheckCircle, Warning, Security, Info } from "@mui/icons-material";
import axios from "../../Axios/index";
import { useNavigate } from "react-router-dom";
import {toast , Toaster} from 'react-hot-toast'
const index = ({marginZero}) => {
  const [open, setOpen] = useState(false);
  const [email , setEmail] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if(!email){
      toast.error("Please provide email")
    }
    
    try {
      const response = await axios.post('otp/sendContactUsEmail', {
        name: "User from news letter",
        email: email,
        message: "I am a new subscriber of My Favorite Things"
      });

      if (response.status == 200) {
        toast.success("Subscribed successfully!");
        setEmail('')
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  return (
    <div>
      <Toaster />
      <section class="footer_section" style={{marginTop: marginZero? 0 : 40}}>
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-4">
              <div class="footer_milk">
              <a class="navbar-brand" href="./index.html">
                <img src={logo} alt="" />
              </a>
                <p onClick={()=> navigate('/privacy-policy')} style={{color:'black', fontWeight:600, fontSize: 16 , cursor : 'pointer'}}>Privacy Policy</p>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="footer_help">
                <h4 style={{color: 'black', fontWeight: 500}}>TALK TO US</h4>
                <ul class="p-0">
                <li>
                <a 
                  href="ContactUs" 
                  style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
                  onMouseOver={(e) => (e.target.style.color = "black")} 
                  onMouseOut={(e) => (e.target.style.color = "inherit")}
                >
                Contact us
                </a>
</li>
                  
                  <li>
  <a 
    href="/userDashboard" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
  Shipping & Returns
  </a>
</li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="footer_help">
              <h4 style={{color: 'black', fontWeight: 500}}>HELP</h4>
                <ul class="p-0">
                <ul class="p-0">
                <li>
  <a 
    href="ContactUs" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
    Addresses
  </a>
</li>
<li>
  <a 
    href="/userDashboard" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
    Order Status
  </a>
</li>
<li>
  <a 
    href="/favourites" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
    Wishlist
  </a>
</li>
<li onClick={handleOpen}>
  <a 
   
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
    Terms And Conditions
  </a>
</li>

</ul>

                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="footer_help">
              <h4 style={{color: 'black', fontWeight: 500}}>PAGES</h4>
                <ul class="p-0">
               
                  <li>
  <a 
    href="AboutUs" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
  About us
  </a>
</li>
<li>
  <a 
    href="/shop" 
    style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }} 
    onMouseOver={(e) => (e.target.style.color = "black")} 
    onMouseOut={(e) => (e.target.style.color = "inherit")}
  >
  Shop
  </a>
</li>
                
                </ul>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-12">
              <div class="footer_signin">
              <h4 style={{color: 'black', fontWeight: 500}}>SIGN UP FOR EMAILS</h4>

          
                <p>Stay informed, subscribe to our newsletter now!</p>
                <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required name="email" id="" placeholder="Email" />
                <div class="footer_btn">
                  <button onClick={handleSubmit} style={{color:'black'}}>Subscribe</button>
                  <i style={{marginLeft:7}} class="fa-solid fa-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <hr style={{ color: " white;" }} />
        <div class="container">
          <div class="row">
            <div class="footer_beauty">
              <p>© 2023 Bloom Beauty </p>
              <div class="privacy_text">
                <p>Privacy Policy</p>
                <p>terms and conditions</p>
              </div>
            </div>
          </div>
        </div> */}
      </section>
      <Modal open={open} onClose={handleClose} aria-labelledby="terms-modal">
      <Box
  sx={{
    width: "80%",
    maxWidth: 600,
    bgcolor: "#db9ea9",
    color: "#000",
    paddingTop: 3,
    paddingBottom:3,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 3,
    boxShadow: 3,
    outline: "none",
  }}
>

          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", textAlign: "center" }}>
            Terms & Conditions
          </Typography>

          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <Gavel sx={{ color: "yellow" }} />
              </ListItemIcon>
              <ListItemText primary="By using our services, you agree to comply with our policies." />
            </ListItem>

            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <CheckCircle sx={{ color: "yellow" }} />
              </ListItemIcon>
              <ListItemText primary="All users must provide accurate and up-to-date information." />
            </ListItem>

            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <Warning sx={{ color: "yellow" }} />
              </ListItemIcon>
              <ListItemText primary="Misuse of services may result in account suspension." />
            </ListItem>

            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <Security sx={{ color: "yellow" }} />
              </ListItemIcon>
              <ListItemText primary="We prioritize user privacy and data security at all times." />
            </ListItem>

            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <Info sx={{ color: "yellow" }} />
              </ListItemIcon>
              <ListItemText primary="For any concerns or queries, please contact our support team." />
            </ListItem>
          </List>

          <Box sx={{ textAlign: "center", mt: 3 }}>
            <Button variant="contained" style={{background: '#ad5e13'}} onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default index;
